module.exports = __webpack_public_path__ + "img/icon5.03f5b2cd.png";